import axios from "axios";
import { showLoading } from "./../../../module/loading";
import { hideLoading } from "./../../../module/loading";
/**
 * 資料をもらう/ダウンロード完了の初期化
 */
export function initSampleSeriesWeboothDownload() {
    initDownloadButton();
    initCheckboxes();
}
/**
 * チェックボックスの初期化
 */
function initCheckboxes() {
    const inputs = document.querySelectorAll('[id^="webooth-download-checkbox-"]');
    for (const input of inputs) {
        input.addEventListener("change", () => {
            let disabled = true;
            for (const input of inputs) {
                if (input.checked) {
                    disabled = false;
                }
            }
            const button = document.getElementById("sample-series-webooth-download-button");
            button.disabled = disabled;
        });
    }
}
/**
 * 資料をもらうボタンの初期化
 */
function initDownloadButton() {
    const button = document.getElementById("sample-series-webooth-download-button");
    if (button === null)
        return;
    button.addEventListener("click", async () => {
        showLoading();
        const dict = {};
        const common_data = document.getElementById("webooth-download-common-data");
        const weboothSlotId = common_data.dataset.weboothSlotId;
        const downloadInputs = document.querySelectorAll('[id^="webooth-download-checkbox-"]');
        for (const input of downloadInputs) {
            dict[input.dataset.id] = input.checked;
        }
        const link = document.createElement("a");
        document.body.appendChild(link);
        for (const input of downloadInputs) {
            if (input.checked) {
                const url = input.dataset.url;
                const xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                // Blobオブジェクトとしてダウンロードする
                xhr.responseType = "blob";
                xhr.onload = function () {
                    const blob = xhr.response;
                    const fileName = input.dataset.name;
                    const objUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = objUrl;
                    link.download = fileName;
                    link.click();
                };
                // XMLHttpRequestオブジェクトの通信を開始する
                xhr.send();
            }
        }
        link.remove();
        const postData = {
            webooth_slot_id: weboothSlotId,
            document_ids: [],
            webooth_questionnaire_id: null,
            answers: {
                answer_1: null,
                answer_2: null,
                answer_3: null,
            },
        };
        const downloadQuestionnaireTable = document.getElementById("download-questionnaire-table");
        const completeQuestionnaireTable = document.getElementById("complete-questionnaire-table");
        if (downloadQuestionnaireTable !== null && completeQuestionnaireTable !== null) {
            const downloadInput1 = document.getElementById("download-questionnaire-input-1");
            const downloadInput2 = document.getElementById("download-questionnaire-input-2");
            const downloadInput3 = document.getElementById("download-questionnaire-input-3");
            postData.webooth_questionnaire_id = downloadQuestionnaireTable.dataset.id;
            postData.answers.answer_1 = downloadInput1.value;
            postData.answers.answer_2 = downloadInput2.value;
            postData.answers.answer_3 = downloadInput3.value;
        }
        for (const input of downloadInputs) {
            if (input.checked) {
                postData.document_ids.push(input.dataset.id);
            }
        }
        try {
            const res = await axios.post("/api/webooth-document-download", postData);
            if (postData.answers.answer_1 !== null || postData.answers.answer_2 !== null || postData.answers.answer_3 !== null) {
                const completeInput1 = document.getElementById("complete-questionnaire-input-1");
                const completeInput2 = document.getElementById("complete-questionnaire-input-2");
                const completeInput3 = document.getElementById("complete-questionnaire-input-3");
                completeInput1.value = postData.answers.answer_1;
                completeInput2.value = postData.answers.answer_2;
                completeInput3.value = postData.answers.answer_3;
                downloadQuestionnaireTable.setAttribute("hidden", "hidden");
            }
            window.console.log(res);
            hideLoading();
        }
        catch (error) {
            hideLoading();
            window.console.error(error);
            alert("資料DL履歴の保存に失敗しました");
            return;
        }
        const completeInputs = document.querySelectorAll('[id^="webooth-download-complete-checkbox-"]');
        for (const input of completeInputs) {
            input.checked = dict[input.dataset.id];
        }
        const downloadMain = document.getElementById("sample-series-webooth-download-main");
        const completeMain = document.getElementById("sample-series-webooth-download-complete-main");
        downloadMain.style.display = "none";
        completeMain.style.display = "block";
    });
}
